/**
 * Decisions on requests to Sercan (twin.requests), panel only
 * (specs/c2-kontratlar.md 2.4.3 and 2.5).
 */
import { z } from 'zod';
import { idStringSchema, isoDateSchema, requestRejectCodeSchema, telegramUserIdSchema } from '../ids.js';
/** POST /api/v1/requests/{id}/answer. */
export const answerRequestBodySchema = z.strictObject({
    text: z.string().min(1).max(4000),
    addToKb: z.boolean(),
});
/**
 * POST /api/v1/requests/{id}/telegram-answer (v0.1.77, bot surface): Sercan answers a question
 * card from Telegram. The bot names the Telegram user and chat; the api maps the user to the
 * owner and accepts private chats only, like the two-step approval. Same effects as answer.
 */
export const telegramAnswerRequestBodySchema = z.strictObject({
    text: z.string().min(1).max(4000),
    addToKb: z.boolean().default(true),
    telegramUserId: telegramUserIdSchema,
    telegramChatId: z.number().int(),
    chatType: z.enum(['private', 'group', 'supergroup', 'channel']),
});
/** POST /api/v1/requests/{id}/accept: target_at = targetDate 23:59 Europe/Istanbul. */
export const acceptRequestBodySchema = z.strictObject({
    targetDate: isoDateSchema,
    note: z.string().max(1000),
});
/** POST /api/v1/requests/{id}/postpone: postponed_until = until 09:00 Europe/Istanbul. */
export const postponeRequestBodySchema = z.strictObject({ until: isoDateSchema });
/** POST /api/v1/requests/{id}/reject. */
export const rejectRequestBodySchema = z.strictObject({
    reasonCode: requestRejectCodeSchema,
    note: z.string().max(1000),
});
export const REQUEST_STATUS_VALUES = ['open', 'accepted', 'postponed', 'rejected', 'done', 'cancelled'];
export const requestDecisionResponseSchema = z.object({
    requestId: idStringSchema,
    status: z.enum(REQUEST_STATUS_VALUES),
    /** Set only when a kb_draft task was opened for the answer. */
    followUpTaskId: idStringSchema.nullable(),
    /** v0.1.42: the Temsilci's customer_reply task opened by an answer to a question from a customer conversation. */
    replyTaskId: idStringSchema.nullable(),
});
/** Hour of day (Europe/Istanbul) the API stores for accept (23:59) and postpone (09:00). */
export const REQUEST_ACCEPT_LOCAL_TIME = '23:59';
export const REQUEST_POSTPONE_LOCAL_TIME = '09:00';
//# sourceMappingURL=requests.js.map